import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTable"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Form, Dropdown, Button, Message } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import cmsStore from "stores/cmsStore.js"
import "style/CheckoutPage.scss"
import HeaderCheckout from "../../../../pages/checkout/HeaderCheckout"
import queryString from "qs"
import CartExport from "components/Cart/CartExport"

@observer
export default class CheckoutPage extends Component {

  constructor() {
    super();

    this.updateCostCentres = this.updateCostCentres.bind(this);

    this.state = { products: getProducts(), costcentres: [] };

    // check for forced cost centre selection
    if (shop.session.shopuser.forceCostcentre || shop.session.value.forceCostcentre) {
      console.log('load cost centres');
//      this.updateCostCentres();
    }

  }

  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    track.checkout( { step: 1, products: shop.cart.products } )
  }

  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }

  updateCart = () => {
    let products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }

  async updateCostCentres() {
    shop.fetch(`/shop/rest/costcentre/data?start=0&count=120&customer=${encodeURIComponent(shop.session.value.map_id)}`).then((data) => {
      console.log(data);
    })
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products } = this.state
    const { loading } = shop.cart
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType

    // MINDERMENGENZUSCHLAG UNTER 50 EUR
    const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE

    const showPenaltyNotice = shop.cart.sum < MIN_ORDER

    return (
      <div className=" ">
        <HeaderCheckout activeStep={0} isRequest={isRequest} referer={referer}/>

        {(shop.session.shopuser.forceCostcentre || shop.session.value.forceCostcentre) &&
        <section className="container">
          <div className="ui form">
            <div className="inline field">
              <label>{ translate("Kostenstelle")}</label>
              <Dropdown fluid search selection options={this.state.costcentres}/>
            </div>
          </div>
        </section>}

        <section className="container">
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
          <div className="cf pt3 pb3">
            <div className="fr">
              <CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
            </div>
          </div>

          {showPenaltyNotice && <Message>
            <div>{translate( "MIN_ORDER_VALUE_NOTICE", { value: `${shop.config.MIN_ORDER_PENALTY_VALUE}` } )}</div>
          </Message>}

          {cmsStore.pluginData.export && <div className="pv3">
            <CartExport/>
          </div>}
        </section>

        <section className="pa2 mb4 ">
          <div className="container">
            <div className="flex flex-row justify-end">

              <Link className={"mr3"} to={referer}>
                <Button>
                  <i className="icon-angle-left"/>
                  {translate( "Zurück" )}
                </Button>
              </Link>

              {!shop.session.handId && <Link to={{
                pathname: `${this.props.location.pathname}delivery`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}

              {shop.session.handId && <Link to={`${this.props.location.pathname}discount`}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
            </div>

          </div>
        </section>


      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product )



// WEBPACK FOOTER //
// ./src/theme/oehme/pages/checkout/CheckoutPage.js